<script setup>
import { Check } from 'lucide-vue-next'
import { status } from '../lib/status'

defineProps({
  steps: { type: Array, required: true },
})
</script>

<template>
  <p v-if="!steps.length" class="text-sm text-slate-500">
    Nenhuma etapa cadastrada nesta ordem de serviço.
  </p>

  <ol v-else class="relative" aria-label="Etapas da manutenção">
    <li
      v-for="(step, i) in steps"
      :key="step.label"
      class="relative flex gap-4 pb-6 last:pb-0"
      :aria-current="step.state === 'active' ? 'step' : undefined"
    >
      <!-- Trilho vertical até a próxima etapa -->
      <span
        v-if="i < steps.length - 1"
        class="absolute left-[13px] top-7 h-full w-0.5"
        :class="steps[i + 1].state === 'pending' ? 'bg-slate-200' : 'bg-up-orange'"
        aria-hidden="true"
      />

      <span
        class="relative z-10 flex h-7 w-7 shrink-0 items-center justify-center rounded-full"
        :class="step.state === 'active'
          ? 'bg-white ring-[3px] ring-up-orange'
          : step.state === 'done' ? 'bg-up-orange text-white' : 'bg-slate-200'"
        aria-hidden="true"
      >
        <Check v-if="step.state === 'done'" class="h-4 w-4" stroke-width="3" />
        <span v-else-if="step.state === 'active'" class="h-2.5 w-2.5 rounded-full bg-up-orange" />
      </span>

      <div class="min-w-0 pt-0.5">
        <p class="flex flex-wrap items-baseline gap-x-3">
          <span
            class="font-semibold"
            :class="step.state === 'pending' ? 'text-up-gray' : 'text-up-navy'"
          >{{ step.label }}</span>
          <span class="text-xs" :class="status(step.state).text">{{ step.date }}</span>
          <span class="sr-only">{{ status(step.state).label }}</span>
        </p>
        <p class="mt-1 text-sm leading-relaxed text-slate-500">{{ step.detail }}</p>
      </div>
    </li>
  </ol>
</template>
